import { LinearProgress, withStyles } from '@material-ui/core'
import { INFO_COLORS } from 'asterX-UI'

export const managerFileCategories = [
  'Справка о задолженности',
  'Расписка о признании задолженности',
  'Претензии и требование',
  'Заявление о взыскании',
  'Заявление от клиента',
  'Ответ на заявление клиента',
  'Запросы АФР',
  'Ответы для АФР',
  'Заявление о принятии исполнительного документа на исполнение'
]

export const lawyerFileCategories = [
  'Исковое заявление',
  'Уведомление об отправке искового заявления через судебный кабинет',
  'Уведомление об отправке искового заявления с отметкой суда о принятии',
  'Определение о принятии',
  'Решение суда 1 ой инстанции',
  'Апелляционная жалоба',
  'Постановление суда апелляционной инстанции',
  'Кассационная жалоба',
  'Постановление суда кассационной  инстанции',
  'Исполнительный лист'
]

export const BorderLinearProgress = withStyles(theme => ({
  root: {
    height: 8,
    borderRadius: 5
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700]
  },
  bar: {
    borderRadius: 5,
    backgroundColor: INFO_COLORS[600]
  }
}))(LinearProgress)
